import { Component, computed, input } from '@angular/core';
import { CopyOnHoverDirective } from '@myarvato/shared/copy';
import { DayjsPipe } from '@myarvato/shared/pipelines';
import { EventDto } from '@myarvato/modules/transport/models';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'transport-event',
  imports: [DayjsPipe, CopyOnHoverDirective, TranslatePipe],
  templateUrl: './event.component.html',
  styleUrl: './event.component.scss',
})
export class EventComponent {
  // Inputs
  public readonly eventData = input.required<EventDto>();

  protected readonly harmonizedEvent = computed(() => {
    return this.eventData().eventDescription ?? '';
  });

  protected readonly isException = computed(() => {
    const event = this.eventData();

    const severity = (event.severity ?? '').trim().toUpperCase();
    return severity === 'EXCEPTION';
  });

  protected readonly location = computed(() => {
    const event = this.eventData();
    const locationParts: string[] = [];
    if (event.eventLocation?.county) {
      locationParts.push(event.eventLocation.county);
    }
    if (event.eventLocation?.city) {
      locationParts.push(event.eventLocation.city);
    }
    if (locationParts.length > 0) {
      return locationParts.join(' • ');
    }
    return undefined;
  });

  protected readonly technicalInfo = computed(() => {
    const event = this.eventData();
    const informationList: string[] = [];

    if (event.codeExternal) {
      informationList.push(event.codeExternal);
    }
    if (event.eventReasonDescription) {
      informationList.push(event.eventReasonDescription);
    }
    if (event.actor) {
      informationList.push(event.actor);
    }

    return informationList.join(', ');
  });
}
